module.exports = __webpack_public_path__ + "static/sf_8.3f7fa790.png";